import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const SettingsModalContainer = styled(Modal)`
  font-family: "Geist", sans-serif;

  .modal-dialog {
    max-width: 960px;
    width: calc(100% - 32px);
  }

  .modal-content {
    height: min(680px, calc(100vh - 64px));
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-radius: 16px;
    background: #fff;
    overflow: hidden;
  }

  .modal-body {
    display: flex;
    height: 100%;
    min-height: 0;
    padding: 0;
  }

  @media (max-width: 768px) {
    .modal-body {
      flex-direction: column;
    }
  }
`;

export const Sidebar = styled.nav`
  display: flex;
  flex: 0 0 248px;
  flex-direction: column;
  padding: 16px 12px;
  background: #fafafa;
  border-right: 1px solid rgba(0, 0, 0, 0.06);

  .sidebar-title {
    padding: 0 10px 6px;
    color: #a3a7ae;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -0.1px;
  }

  .sidebar-nav {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  @media (max-width: 768px) {
    flex: 0 0 auto;
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

    .sidebar-nav {
      flex-direction: row;
      gap: 0;
      overflow-x: auto;
    }

    button {
      gap: 6px;
      padding: 10px 8px;
    }
  }

  @media (max-width: 480px) {
    /* the exported SVGs set display inline, so only !important wins */
    .sidebar-nav button svg {
      display: none !important;
    }
  }
`;

export const SidebarItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #414651;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  &[aria-current="page"] {
    background: #fff;
    color: #181d27;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.06),
      0 0 0 1px rgba(10, 13, 18, 0.05);
    cursor: default;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const Section = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background: #fff;

  .section-header {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 20px 20px 0;
  }

  .section-body {
    flex: 1;
    min-height: 0;
    padding: 8px 40px 40px;
    overflow-y: auto;
  }

  @media (max-width: 768px) {
    .section-body {
      padding: 8px 16px 24px;
    }
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;
